export default __webpack_public_path__ + "static/media/consulting.4f5a9ccf.svg";